import React, { useState, } from 'react';
import GridContainer from '../GridContainer';
import {
    Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
    FormControl, Select, InputLabel,
    TextField,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';

import { CircularProgress } from '@material-ui/core';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';

import HorarioPrestador from 'routes/Pages/FichasTecnicas/Components/FormFichaComponents/HorarioPrestador';
import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { EXCLUDE_FROM_ODONTOLOGIA, PRIVADOS, TEXT_COLOR_FT } from 'config/config';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: theme.palette.common.dark,
        },
    },
}));




const EditModal2 = props => {

    const {
        openDialog = false,
        close,
        dataCrear,
        fields,
        setDataCrear,
        postData,
        estadosAux,
        tiposAux,
        autoridadesAux,
        garantia,
        isEquip,
        espacios,
        isCentroDependiente,
        isGeneralIndiferenciada,
        mantencionAux,
        isOdonto,
        checked,
        handleChange,

    } = props;


    const [loading, setIsLoading] = useState(false)
    const classes = addStyle()

    const onCloseDialog = (event, reason) => {

        if (reason !== 'backdropClick') {
            clearData()
            close();
        }

    };

    const clearData = () => {
        setIsLoading(false)
    }

    const addSpace = () => {
        setIsLoading(true)
        if (!checked) {
            const keysToDelete = [
                "e_lunes_jueves", "s_lunes_jueves", "t_lunes_jueves",
                "e_viernes", "s_viernes", "t_viernes",
                "e_sabados", "s_sabados", "t_sabados",
                "e_domingos", "s_domingos", "t_domingos",
                "e_festivos", "s_festivos", "t_festivos"
            ];

            keysToDelete.forEach(key => {
                delete dataCrear[key];
            });

            dataCrear["data_extra"]=null

        }

        postData(dataCrear)
        onCloseDialog()
    }

    const contentNotEquip = (campo, index) => {
        if (campo.type === 'text' || campo.type === 'number') {

            if (isOdonto && EXCLUDE_FROM_ODONTOLOGIA.includes(dataCrear['nombre']) && (campo.id === 'n_sillones' || campo.id === 'cantidad')) {
                return null
            }
            else if ((dataCrear['id_edo_aut_sanitaria'] !== 1) && campo.id === 'nro_resolucion') {
                return null

            } else if (isGeneralIndiferenciada && (campo.id === 'nro_box' || campo.id === 'nro_camilla') &&
                (dataCrear['nombre'] === 'Botiquín' || dataCrear['nombre'] === 'Sala rayos')
            ) {
                return null
            } else if (dataCrear['id_tipo_servicio'] === 2) {

                if (campo.id === 'nombre' || campo.id === 'nro_resolucion') {
                    return <Grid key={index} item xs={6} sm={6}>
                        <TextField
                            label={campo.label}
                            fullWidth
                            error={dataCrear[campo.id] === '' ? true : false}
                            size='small'
                            variant='outlined'
                            value={dataCrear[campo.id]}
                            onChange={(e) => {
                                if (campo.type === 'number') {
                                    if (e.target.value.length < 12) {
                                        if (/^\d*$/.test(e.target.value)) {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                            }
                                            setDataCrear(aux)
                                        }
                                    }
                                } else {
                                    if (e.target.value.length < 100) {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: e.target.value
                                        }
                                        setDataCrear(aux)
                                    }
                                }
                            }}
                            disabled={campo.id === 'nombre' ? true : false}
                        />
                    </Grid>
                } else {
                    return null
                }

            } else {
                if (dataCrear['otro_nombre'] && campo.id === 'nombre') {
                    return <div key={index}
                        style={{ width: '100%', display: 'flex' }}
                    >
                        <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                            <TextField
                                label={campo.label}
                                fullWidth
                                error={dataCrear[campo.id] === '' ? true : false}
                                size='small'
                                variant='outlined'
                                value={dataCrear[campo.id]}
                                onChange={(e) => {
                                    if (campo.type === 'number') {
                                        if (e.target.value.length < 12) {
                                            if (/^\d*$/.test(e.target.value)) {
                                                let aux = {
                                                    ...dataCrear,
                                                    [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                                }
                                                setDataCrear(aux)
                                            }
                                        }
                                    } else {
                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }
                                    }
                                }}
                                disabled={campo.id === 'nombre' ? true : false}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                            <TextField
                                label={'Nombre personalizado'}
                                fullWidth
                                error={dataCrear['otro_nombre'] === '' ? true : false}
                                size='small'
                                variant='outlined'
                                value={dataCrear['otro_nombre']}
                                onChange={(e) => {

                                    if (e.target.value.length < 100) {
                                        let aux = {
                                            ...dataCrear,
                                            otro_nombre: e.target.value
                                        }
                                        setDataCrear(aux)
                                    }

                                }}
                            />
                        </Grid>
                    </div>
                } else {
                    return <Grid key={index} item xs={6} sm={6}>
                        <TextField
                            label={campo.label}
                            fullWidth
                            error={dataCrear[campo.id] === '' ? true : false}
                            size='small'
                            variant='outlined'
                            value={dataCrear[campo.id]}
                            onChange={(e) => {
                                if (campo.type === 'number') {
                                    if (e.target.value.length < 12) {
                                        if (/^\d*$/.test(e.target.value)) {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                            }
                                            setDataCrear(aux)
                                        }
                                    }
                                } else {
                                    if (e.target.value.length < 100) {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: e.target.value
                                        }
                                        setDataCrear(aux)
                                    }
                                }
                            }}
                            disabled={campo.id === 'nombre' ? true : false}
                        />
                    </Grid>
                }

            }

        } else if (campo.type === 'date') {
            if ((dataCrear['id_edo_aut_sanitaria'] !== 1) && campo.id === 'fecha_resolucion') {

                return null

            } else {
                return <Grid key={index} item xs={6} sm={6}>
                    <TextField
                        label={campo.label}
                        error={dataCrear[campo.id] === '' ? true : false}
                        fullWidth
                        size='small'
                        type="date"
                        variant='outlined'
                        value={dataCrear[campo.id]}
                        onChange={(e) => {

                            if (campo.id === 'fecha_resolucion') {
                                const selectedDate = new Date(e.target.value);
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                selectedDate.setHours(0, 0, 0, 0);
                                const selectedDateString = selectedDate.toISOString().split('T')[0];
                                const todayString = today.toISOString().split('T')[0];

                                if (selectedDateString >= todayString) {
                                    toast.error('La fecha no puede ser futura')
                                } else {
                                    let aux = {
                                        ...dataCrear,
                                        [campo.id]: e.target.value
                                    };
                                    setDataCrear(aux);
                                }
                            } else {
                                let aux = {
                                    ...dataCrear,
                                    [campo.id]: e.target.value
                                }
                                setDataCrear(aux)
                            }

                        }}
                        InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                    />
                </Grid>
            }
        } else if (campo.type==="name"){
            return null
        }{
            if ((dataCrear['id_edo_aut_sanitaria'] !== 1) && campo.id === 'id_autoridad') {
                return null

            } else {
                if (dataCrear['id_tipo_servicio'] !== 2 && campo.id === "id_tipo_servicio") {
                    return <Grid key={index} item xs={6} sm={6}>
                        <FormControl size='small' fullWidth>
                            <InputLabel
                                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                htmlFor="grouped-native-select"
                                error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                {campo.label}
                            </InputLabel>
                            <Select
                                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                native
                                label={campo.label}
                                error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                id="grouped-native-select"
                                fullWidth
                                variant='outlined'
                                value={dataCrear[campo.id]}
                                onChange={(e) => {
                                    let aux = {
                                        ...dataCrear,
                                        [campo.id]: parseInt(e.target.value)
                                    }
                                    setDataCrear(aux)
                                }}

                            >
                                {getOptions(campo.id)}
                            </Select>
                        </FormControl>

                    </Grid>

                } else if (dataCrear['id_tipo_servicio'] === 2 && campo.id === "id_tipo_servicio") {
                    return <div key={index}
                        style={{ display: 'contents' }}
                    >
                        {dataCrear['otro_nombre'] ?
                            <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                <TextField
                                    label={'Nombre personalizado'}
                                    fullWidth
                                    error={dataCrear['otro_nombre'] === '' ? true : false}
                                    size='small'
                                    variant='outlined'
                                    value={dataCrear['otro_nombre']}
                                    onChange={(e) => {

                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                otro_nombre: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }

                                    }}
                                />
                            </Grid>
                            :
                            null
                        }
                        <Grid key={index} item xs={6} sm={6} style={{ padding: 12 }}>
                            <FormControl size='small' fullWidth>
                                <InputLabel
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    htmlFor="grouped-native-select"
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                    {campo.label}
                                </InputLabel>
                                <Select
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    native
                                    label={campo.label}
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    id="grouped-native-select"
                                    fullWidth
                                    variant='outlined'
                                    value={dataCrear[campo.id]}
                                    onChange={(e) => {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: parseInt(e.target.value)
                                        }
                                        setDataCrear(aux)
                                    }}

                                >
                                    {getOptions(campo.id)}
                                </Select>
                            </FormControl>

                        </Grid>
                        <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                            <TextField
                                label={'Nombre proveedor'}
                                fullWidth
                                error={dataCrear['nombre_proveedor'] === '' ? true : false}
                                size='small'
                                variant='outlined'
                                value={dataCrear['nombre_proveedor']}
                                onChange={(e) => {

                                    if (e.target.value.length < 100) {
                                        let aux = {
                                            ...dataCrear,
                                            nombre_proveedor: e.target.value
                                        }
                                        setDataCrear(aux)
                                    }

                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                            <TextField
                                label={'RUT proveedor'}
                                fullWidth
                                error={!validateRut(dataCrear['rut_proveedor'])}
                                size='small'
                                variant='outlined'
                                value={dataCrear['rut_proveedor']}
                                onChange={(e) => {

                                    let inputRut = e.target.value;
                                    inputRut = inputRut.slice(0, 13);
                                    const formattedRut = formatRut(inputRut);
                                    let aux = {
                                        ...dataCrear,
                                        rut_proveedor: formattedRut
                                    }
                                    setDataCrear(aux)


                                }}
                            />
                        </Grid>
                    </div>
                } else {
                    return <Grid key={index} item xs={6} sm={6}>
                        <FormControl size='small' fullWidth>
                            <InputLabel
                                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                htmlFor="grouped-native-select"
                                error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                {campo.label}
                            </InputLabel>
                            <Select
                                inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                native
                                label={campo.label}
                                error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                id="grouped-native-select"
                                fullWidth
                                variant='outlined'
                                value={dataCrear[campo.id]}
                                onChange={(e) => {
                                    let aux = {
                                        ...dataCrear,
                                        [campo.id]: parseInt(e.target.value)
                                    }
                                    setDataCrear(aux)
                                }}

                            >
                                {getOptions(campo.id)}
                            </Select>
                        </FormControl>

                    </Grid>
                }

            }

        }
    }

    const contentIsEquip = (campo, index) => {

        let needAut = espacios.find(e => e.nombre === dataCrear["nombre"])

        if (needAut) {
            if (campo.type === 'text' || campo.type === 'number') {

                if ((!needAut.requiere_autorizacion) && campo.id === 'nro_resolucion') {

                    return null

                }
                else if (dataCrear['id_tipo_servicio'] === 2) {

                    if (campo.id === 'nombre' || campo.id === 'nro_resolucion') {
                        return <Grid key={index} item xs={6} sm={6}>
                            <TextField
                                label={campo.label}
                                fullWidth
                                error={dataCrear[campo.id] === '' ? true : false}
                                size='small'
                                variant='outlined'
                                value={dataCrear[campo.id]}
                                onChange={(e) => {
                                    if (campo.type === 'number') {
                                        if (e.target.value.length < 12) {
                                            if (/^\d*$/.test(e.target.value)) {
                                                let aux = {
                                                    ...dataCrear,
                                                    [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                                }
                                                setDataCrear(aux)
                                            }
                                        }
                                    } else {
                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }
                                    }
                                }}
                                disabled={campo.id === 'nombre' ? true : false}
                            />
                        </Grid>
                    } else {
                        return null
                    }

                }
                else {
                    if (dataCrear['otro_nombre'] && campo.id === 'nombre') {
                        return <div key={index}
                            style={{ width: '100%', display: 'flex' }}
                        >
                            <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                <TextField
                                    label={campo.label}
                                    fullWidth
                                    error={dataCrear[campo.id] === '' ? true : false}
                                    size='small'
                                    variant='outlined'
                                    value={dataCrear[campo.id]}
                                    onChange={(e) => {
                                        if (campo.type === 'number') {
                                            if (e.target.value.length < 12) {
                                                if (/^\d*$/.test(e.target.value)) {
                                                    let aux = {
                                                        ...dataCrear,
                                                        [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                                    }
                                                    setDataCrear(aux)
                                                }
                                            }
                                        } else {
                                            if (e.target.value.length < 100) {
                                                let aux = {
                                                    ...dataCrear,
                                                    [campo.id]: e.target.value
                                                }
                                                setDataCrear(aux)
                                            }
                                        }
                                    }}
                                    disabled={campo.id === 'nombre' ? true : false}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                <TextField
                                    label={'Nombre personalizado'}
                                    fullWidth
                                    error={dataCrear['otro_nombre'] === '' ? true : false}
                                    size='small'
                                    variant='outlined'
                                    value={dataCrear['otro_nombre']}
                                    onChange={(e) => {

                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                otro_nombre: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }

                                    }}
                                />
                            </Grid>
                        </div>
                    } else {
                        return <Grid key={index} item xs={6} sm={6}>
                            <TextField
                                label={campo.label}
                                fullWidth
                                error={dataCrear[campo.id] === '' ? true : false}
                                size='small'
                                variant='outlined'
                                value={dataCrear[campo.id]}
                                onChange={(e) => {
                                    if (campo.type === 'number') {
                                        if (e.target.value.length < 12) {
                                            if (/^\d*$/.test(e.target.value)) {
                                                let aux = {
                                                    ...dataCrear,
                                                    [campo.id]: e.target.value !== '' ? parseInt(e.target.value) : ''
                                                }
                                                setDataCrear(aux)
                                            }
                                        }
                                    } else {
                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }
                                    }
                                }}
                                disabled={campo.id === 'nombre' ? true : false}
                            />
                        </Grid>
                    }

                }

            } else if (campo.type === 'date') {
                if ((!needAut.requiere_autorizacion) && campo.id === 'fecha_resolucion') {


                    return null

                } else if (dataCrear['garantia_vigente'] === 2 && campo.id === 'fecha_expiracion') {
                    return null
                } else {

                    return <Grid key={index} item xs={6} sm={6}>
                        <TextField
                            label={campo.label}
                            error={dataCrear[campo.id] === '' ? true : false}
                            fullWidth
                            size='small'
                            type="date"
                            variant='outlined'
                            value={dataCrear[campo.id]}
                            onChange={(e) => {


                                if (campo.id === 'fecha_resolucion') {
                                    const selectedDate = new Date(e.target.value);
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0);
                                    selectedDate.setHours(0, 0, 0, 0);
                                    const selectedDateString = selectedDate.toISOString().split('T')[0];
                                    const todayString = today.toISOString().split('T')[0];

                                    if (selectedDateString >= todayString) {
                                        toast.error('La fecha no puede ser futura')
                                    } else {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: e.target.value
                                        };
                                        setDataCrear(aux);
                                    }
                                } else {
                                    let aux = {
                                        ...dataCrear,
                                        [campo.id]: e.target.value
                                    }
                                    setDataCrear(aux)
                                }
                            }}
                            InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                        />
                    </Grid>
                }
            } else {
                if ((!needAut.requiere_autorizacion) && campo.id === 'id_autoridad') {
                    return null

                } else {
                    if (dataCrear['id_tipo_servicio'] !== 2 && campo.id === "id_tipo_servicio") {
                        return <Grid key={index} item xs={6} sm={6}>
                            <FormControl size='small' fullWidth>
                                <InputLabel
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    htmlFor="grouped-native-select"
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                    {campo.label}
                                </InputLabel>
                                <Select
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    native
                                    label={campo.label}
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    id="grouped-native-select"
                                    fullWidth
                                    variant='outlined'
                                    value={dataCrear[campo.id]}
                                    onChange={(e) => {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: parseInt(e.target.value)
                                        }
                                        setDataCrear(aux)
                                    }}

                                >
                                    {getOptions(campo.id)}
                                </Select>
                            </FormControl>

                        </Grid>

                    } else if (dataCrear['id_tipo_servicio'] === 2 && campo.id === "id_tipo_servicio") {
                        return <div key={index}
                            style={{ display: 'contents' }}
                        >
                            {dataCrear['otro_nombre'] ?
                                <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                    <TextField
                                        label={'Nombre personalizado'}
                                        fullWidth
                                        error={dataCrear['otro_nombre'] === '' ? true : false}
                                        size='small'
                                        variant='outlined'
                                        value={dataCrear['otro_nombre']}
                                        onChange={(e) => {

                                            if (e.target.value.length < 100) {
                                                let aux = {
                                                    ...dataCrear,
                                                    otro_nombre: e.target.value
                                                }
                                                setDataCrear(aux)
                                            }

                                        }}
                                    />
                                </Grid>
                                :
                                null
                            }
                            <Grid key={index} item xs={6} sm={6} style={{ padding: 12 }}>
                                <FormControl size='small' fullWidth>
                                    <InputLabel
                                        inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                        htmlFor="grouped-native-select"
                                        error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                        style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                        {campo.label}
                                    </InputLabel>
                                    <Select
                                        inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                        native
                                        label={campo.label}
                                        error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                        id="grouped-native-select"
                                        fullWidth
                                        variant='outlined'
                                        value={dataCrear[campo.id]}
                                        onChange={(e) => {
                                            let aux = {
                                                ...dataCrear,
                                                [campo.id]: parseInt(e.target.value)
                                            }
                                            setDataCrear(aux)
                                        }}

                                    >
                                        {getOptions(campo.id)}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                <TextField
                                    label={'Nombre proveedor'}
                                    fullWidth
                                    error={dataCrear['nombre_proveedor'] === '' ? true : false}
                                    size='small'
                                    variant='outlined'
                                    value={dataCrear['nombre_proveedor']}
                                    onChange={(e) => {

                                        if (e.target.value.length < 100) {
                                            let aux = {
                                                ...dataCrear,
                                                nombre_proveedor: e.target.value
                                            }
                                            setDataCrear(aux)
                                        }

                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} container style={{ padding: 12 }}>
                                <TextField
                                    label={'RUT proveedor'}
                                    fullWidth
                                    error={!validateRut(dataCrear['rut_proveedor'])}
                                    size='small'
                                    variant='outlined'
                                    value={dataCrear['rut_proveedor']}
                                    onChange={(e) => {

                                        let inputRut = e.target.value;
                                        inputRut = inputRut.slice(0, 13);
                                        const formattedRut = formatRut(inputRut);
                                        let aux = {
                                            ...dataCrear,
                                            rut_proveedor: formattedRut
                                        }
                                        setDataCrear(aux)


                                    }}
                                />
                            </Grid>
                        </div>
                    } else {
                        return <Grid key={index} item xs={6} sm={6}>
                            <FormControl size='small' fullWidth>
                                <InputLabel
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    htmlFor="grouped-native-select"
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                    {campo.label}
                                </InputLabel>
                                <Select
                                    inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
                                    native
                                    label={campo.label}
                                    error={dataCrear[campo.id] === 0 || dataCrear[campo.id] === '' ? true : false}
                                    id="grouped-native-select"
                                    fullWidth
                                    variant='outlined'
                                    value={dataCrear[campo.id]}
                                    onChange={(e) => {
                                        let aux = {
                                            ...dataCrear,
                                            [campo.id]: parseInt(e.target.value)
                                        }
                                        setDataCrear(aux)
                                    }}

                                >
                                    {getOptions(campo.id)}
                                </Select>
                            </FormControl>

                        </Grid>
                    }

                }

            }
        } else {
            return null
        }


    }

    const getModalContent = () => {

        return fields.map((campo, index) => {

            if (isEquip) {

                return contentIsEquip(campo, index)
            } else {

                return contentNotEquip(campo, index)
            }

        })
    }

    const optionsReturn = (arr) => {
        return arr.map((item, index) => {
            return <option key={index} value={item.value}> {item.label}</option>
        })
    }

    const getOptions = (campo) => {

        switch (campo) {
            case 'id_tipo_servicio': return optionsReturn(tiposAux)
            case 'id_edo_aut_sanitaria': return optionsReturn(estadosAux)
            case 'id_autoridad': return optionsReturn(autoridadesAux)
            case 'garantia_vigente': return optionsReturn(garantia)
            case 'periodicidad_mantencion': return optionsReturn(mantencionAux)
            default: return optionsReturn(tiposAux)
        }

    }

    const validateForm = () => {

        let idEdoAutSanitaria = ''
        if (isEquip) {
            let aux = espacios.find(e => e.nombre === dataCrear["nombre"])
            if (aux) {
                idEdoAutSanitaria = aux.requiere_autorizacion ? 1 : 3
            } else {
                idEdoAutSanitaria = 3
            }
        } else {
            idEdoAutSanitaria = dataCrear.id_edo_aut_sanitaria;
        }

        const fieldsToValidate = Object.keys(dataCrear).filter(field => {

            if (idEdoAutSanitaria !== 1 && (field === 'nro_resolucion' || field === 'fecha_resolucion' || field === 'id_autoridad')) {

                return false;
            }

            if (isGeneralIndiferenciada && (field === 'nro_box' || field === 'nro_camilla') && (dataCrear['nombre'] === 'Botiquín' || dataCrear['nombre'] === 'Sala rayos')) {
                return false
            }

            if (isEquip && dataCrear['garantia_vigente'] === 2 && field === 'fecha_expiracion') {
                return false
            }

            if (dataCrear['id_tipo_servicio'] !== 2 && (field === 'rut_proveedor' || field === 'nombre_proveedor')) {
                return false
            }

            if (isOdonto && EXCLUDE_FROM_ODONTOLOGIA.includes(dataCrear['nombre']) && (field === 'n_sillones' || field === 'cantidad')) {
                return false
            }

            if (isEquip) {
                if (dataCrear['id_tipo_servicio'] === 2) {

                    if (field === 'rut_proveedor' ||
                        field === 'nombre_proveedor' ||
                        field === 'nro_resolucion' ||
                        field === 'fecha_resolucion' ||
                        field === 'id_autoridad' ||
                        field === 'otro_nombre' ||
                        field === 'garantia_vigente' ||
                        field === 'fecha_expiracion'
                    ) {
                        return true
                    } else {
                        return false
                    }

                }
            } else {
                if (dataCrear['id_tipo_servicio'] === 2) {

                    if (field === 'rut_proveedor' || field === 'nombre_proveedor' || field === 'nro_resolucion' || field === 'fecha_resolucion' || field === 'id_autoridad' || field === 'otro_nombre') {
                        if (field === 'otro_nombre') {
                            if (dataCrear['otro_nombre']) {
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return true
                        }

                    } else {
                        return false
                    }

                }
            }
            return true;

        });

        if ((idEdoAutSanitaria === 0 || idEdoAutSanitaria === '' || idEdoAutSanitaria === undefined)) {

            return true
        } else {

            return !fieldsToValidate.every(field => {
                if (dataCrear['id_tipo_servicio'] === 2) {
                    if (field === 'rut_proveedor') {
                        return validateRut(dataCrear['rut_proveedor'])
                    }
                }

                return dataCrear[field] !== ''
            });
        }

    };

    const validateHorario = (data) => {

        Object.entries(data).forEach(([key, value]) => {
            setDataCrear(prevDataCrear => ({
                ...prevDataCrear,
                [key]: value
            }));
        });

    }

    const getBtnDisabled = () => {

        if (isCentroDependiente) {

            return validateForm()
        } else {
            return validateForm()
        }
    }


    return (
        <Dialog open={openDialog} onClose={onCloseDialog}>
            <CustomToast />
            <DialogTitle className={classes.dialogTitleRoot}>
                <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
                    <Grid item >
                        {dataCrear.nombre ? 'Editar ' + dataCrear.nombre : null}
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
                    <GridContainer>

                        {

                            getModalContent()

                        }
                        {
                            isCentroDependiente ?
                                <HorarioPrestador validateHorario={validateHorario} />
                                :
                                null
                        }
                        {
                            (PRIVADOS === sessionStorage.getItem("tipo_administracion") && !isEquip) ?
                                <Grid container item justifyContent="center">
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            label="¿Maneja horario distinto?"
                                            control={
                                                <Checkbox checked={checked} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} />
                                            }
                                        />
                                    </Grid>
                                </Grid>
                                :
                                null
                        }

                        {
                            checked ?
                                <HorarioPrestador validateHorario={validateHorario} editing={true} dataCrear={dataCrear.data_extra} />
                                :
                                null
                        }
                    </GridContainer>
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
                        {"Cerrar"}
                    </Button>
                    <Box ml={2}>
                        {<Button variant="outlined" color="primary" onClick={() => { addSpace() }}
                            disabled={
                                getBtnDisabled()
                            }>
                            <Save style={{marginRight:10}} />
                            {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Actualizar'}
                        </Button>
                        }

                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default EditModal2;
